import React from 'react';
import Button from '../../common/Button';
import './AboutIntro.css';

const AboutIntro = () => {
  return (
    <section className="section about-intro">
      <div className="container">
        <div className="about-intro__content">
          <div className="about-intro__main">
            <h2>Meet Kirstie</h2>

            <div className="about-intro__image">
              <img
                src="/images/kirstie-portrait.jpg"
                alt="Kirstie Warburton - Holistic Health Practitioner & Reiki Master Teacher in Sydney"
                className="about-intro__portrait"
                loading="eager"
                decoding="async"
                fetchPriority="high"
              />
            </div>

            <p className="about-intro__lead">
              Holistic healer and lightworker holding space for your transformation
            </p>
            <p>
              Kirstie is a holistic healer and lightworker who has spent over three decades holding space
              for people—first as a nurse, and now as a guide for those moving from overwhelm into ease.
              She has supported hundreds of women and men through low seasons of life, helping them find
              their way back to more flow, presence, and abundance.
            </p>
            <p>
              From 2017 onward, practices like forgiveness, meditation, clear boundaries, and
              heart-centred presence reshaped her life. What felt broken slowly revealed its wisdom.
              With patience and steady practice, fear softened, and space opened for abundance,
              compassion, and a renewed sense of self.
            </p>
            <p>
              Her work blends soul-led intuition with grounded tools. Kirstie draws on intuitive Reiki,
              chakra balancing, guided meditation, spiritual life coaching, tarot, oracle cards,
              energy clearing, and bespoke ceremonies to support lasting change.
            </p>
            <div className="about-intro__cta">
              <Button href="/about" size="large">
                Read Kirstie's Full Story
              </Button>
            </div>
          </div>

          <div className="about-intro__credentials">
            <h3>Credentials & Certifications</h3>
            <ul className="credentials-list">
              <li>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                </svg>
                Reiki Master Teacher
              </li>
              <li>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                </svg>
                Restorative Yin Instructor
              </li>
              <li>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                </svg>
                Meditation Teacher
              </li>
              <li>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                </svg>
                Soul Coaching Practitioner
              </li>
              <li>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                </svg>
                Chakra Healer Master (CCHM Dip)
              </li>
              <li>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                </svg>
                Biddy Tarot Certified Counsellor
              </li>
            </ul>
            <div className="memberships">
              <h4>Professional Memberships</h4>
              <p>International Institute for Complementary Therapies</p>
              <p>Reiki Healing Association</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutIntro;
